// src/pages/Works.jsx
import React from "react";
import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { styles } from "../styles";
import { github } from "../assets";
import { SectionWrapper } from "../hoc";
import { projects } from "../constants";
import { fadeIn, textVariant } from "../utils/motion";

/* ---------------------- VIDEO MULTIDIOMA ---------------------- */
const PromoVideo = () => {
  const { i18n, t } = useTranslation();
  const lang = i18n.language;

  const videos = {
    ca: "/docs/LivingSoils-cat.mp4",
    es: "/docs/LivingSoils-cast.mp4",
    en: "/docs/LivingSoils-ingles.mp4",
  };

  const src = videos[lang] || videos["ca"];

  return (
    <motion.div
      variants={fadeIn("up", "spring", 0.1, 0.75)}
      className="relative w-full max-w-6xl mx-auto overflow-hidden rounded-2xl shadow-2xl mt-10 bg-black"
    >
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        <video
          src={src}
          className="absolute inset-0 w-full h-full object-cover"
          controls
          preload="metadata"
        >
          {t("works.videoFallback", "Your browser does not support the video tag.")}
        </video>
      </div>
    </motion.div>
  );
};

/* ---------------------- CARD PROJECTE ---------------------- */
const ProjectCard = ({
  index,
  name,
  description,
  tags,
  image,
  source_code_link,
}) => {
  const { t } = useTranslation();

  return (
    <motion.div variants={fadeIn("up", "spring", index * 0.5, 0.75)} className="w-full min-w-0 sm:w-auto">
      <Tilt
        options={{ max: 45, scale: 1, speed: 450 }}
        className="bg-tertiary p-5 rounded-2xl w-full max-w-[360px] min-h-[520px] sm:min-h-[550px] flex flex-col"
      >
        <div className="relative w-full h-[230px]">
          <img
            src={image}
            alt={t("works.projectImageAlt")}
            className="w-full h-full object-cover rounded-2xl"
          />
          <div className="absolute inset-0 flex justify-end m-3 card-img_hover">
            <div
              onClick={() => window.open(source_code_link, "_blank")}
              className="black-gradient w-10 h-10 rounded-full flex justify-center items-center cursor-pointer"
            >
              <img
                src={github}
                alt={t("works.sourceCodeAlt")}
                className="w-1/2 h-1/2 object-contain"
              />
            </div>
          </div>
        </div>

        <div className="mt-5 flex-grow overflow-auto">
          <h3 className="text-white font-bold text-[24px]">{t(name)}</h3>
          <p className="mt-2 text-secondary text-[14px]">{t(description)}</p>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <p
              key={`${name}-${tag.name}`}
              className={`text-[14px] ${tag.color}`}
            >
              #{t(tag.name)}
            </p>
          ))}
        </div>
      </Tilt>
    </motion.div>
  );
};

/* ---------------------- COMPONENT PRINCIPAL ---------------------- */
const Works = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* 🔥 TÍTULO DEL VÍDEO */}
      <motion.div variants={textVariant()}>
        <p
          className={`${styles.sectionSubText}`}
          style={{ color: "black", lineHeight: "1.3" }}
        >
          {t("works.videoSectionSubtitle", "Vídeo promocional")}
        </p>
        <h2 className={`${styles.heroHeadText}`}>
          {t("works.videoSectionTitle", "Vídeo LivingSoils")}
        </h2>
      </motion.div>

      {/* 🎞 VÍDEO MULTIDIOMA */}
      <PromoVideo />

      {/* 🔽 Proyectos */}
      <div className="mt-16 sm:mt-20 flex flex-wrap justify-center gap-5 sm:gap-7">
        {projects.map((project, index) => (
          <ProjectCard key={`project-${index}`} index={index} {...project} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Works, "");
